import { DatePipe } from '@angular/common';
import { Component, Input, SimpleChanges } from '@angular/core';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-download-excel',
  templateUrl: './download-excel.component.html',
  styleUrls: ['./download-excel.component.css'],
})
export class DownloadExcelComponent {
  @Input() data: any[] = [];
  @Input() fileName: string = '';
  @Input() columnsToExport: any[] = [];
  @Input() allColumns: { id?: number; key: string; header: string }[] = []; // Updated to include optional id
  @Input() allRecords: any;
  @Input() exportData: any[] = [];
  @Input() columns: any[] = [];
  @Input() includeLineItems: Boolean = false;
  constructor(private datePipe: DatePipe) {}
  // Map to store header labels with unique identifiers (id or key)
  columnHeaderMap: { [identifier: string]: string } = {};

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['allColumns']) {
      this.columnHeaderMap = this.allColumns.reduce((acc, col) => {
        const identifier = col.id ?? col.key; // Use id if available, otherwise key
        acc[identifier] = col.header;
        return acc;
      }, {} as { [identifier: string]: string });
    }
  }

  exportToExcel(): void {
    if (!this.exportData || this.exportData.length === 0) {
      alert('No data available to export.');
      return;
    }

    // Get export keys based on unique identifiers (id or key)
    const exportIdentifiers =
      this.columns && this.columns.length > 0
        ? this.columns.map((col) => col.id ?? col.key)
        : this.allColumns.map((col) => col.id ?? col.key);

    const processedData = this.exportData.flatMap((row) => {
      const baseRow = this.processRow(row, exportIdentifiers);
      if (baseRow.approvalStatus === 'REJECTED') {
        return [];
      }
      
      if (baseRow.invoiceMonth) {
        const parsedMonthDate = this.parseCustomDate(baseRow.invoiceMonth);
        baseRow.invoiceMonth = parsedMonthDate
          ? this.datePipe.transform(parsedMonthDate, 'MMMM-yyyy')
          : '';
      }

      if (baseRow.invoiceDate) {
        const parsedDate = this.parseCustomDate(baseRow.invoiceDate);
        baseRow.invoiceDate = parsedDate
          ? this.datePipe.transform(parsedDate, 'dd-MM-yyyy')
          : '';
      }

      const lineItems = Array.isArray(row.invoiceLineItems)
        ? row.invoiceLineItems
        : [];
      if (lineItems.length === 0) return [baseRow];

      if (!this.includeLineItems) {
        return [baseRow];
      }

      console.log('baseRow', baseRow);
      const lineItemRows = lineItems
        .filter(
          (lineItem: any) => lineItem.lineItemApprovalStatus !== 'REJECTED'
        )
        .map((lineItem: any) => {
          const expenseMap = (lineItem.invoiceLineItemExpense || []).reduce(
          (acc: any, item: any) => {
            acc[item.attributeName] = item.attributeValue;
            return acc;
          },
          {}
        );
          // let parsedDate: Date | null = null;
          const parsedDate = this.parseCustomDate(lineItem.invoiceDate);
          lineItem.invoiceDate = parsedDate
            ? this.datePipe.transform(parsedDate, 'dd-MM-yyyy')
            : '';
        const fromDate = this.parseCustomDate(lineItem.fromDate);
        lineItem.fromDate = fromDate
          ? this.datePipe.transform(fromDate, 'dd-MM-yyyy')
          : '';
          return {
            ...baseRow,
            VendorInvoiceNumber: lineItem.invoiceNumber,
            PaymentStatus: lineItem.paymentStatus,
            lineItemApprovalStatus: lineItem.lineItemApprovalStatus,
            ReferenceNo: lineItem?.referenceNumber,
            Amount: lineItem.amount,
            SGST: Number(expenseMap['SGST'] || ''),
            CGST: Number(expenseMap['CGST'] || ''),
            IGST: Number(expenseMap['IGST'] || ''),
            BudgetAmount: lineItem.budgetAmount,
            BudgetStatus: lineItem.budgetStatus,
            ExpenseLineItem: lineItem.expense,
            ExpenseType: lineItem.expenseType,
            'Document invoice date': parsedDate
              ? this.datePipe.transform(parsedDate, 'dd-MM-yyyy')
              : '',
          };
        });

      return lineItemRows;
    });

    // Generate headers using the unique identifiers
    const headers = exportIdentifiers.map(
      (identifier) => this.columnHeaderMap[identifier] || identifier.toString()
    );

    // Create worksheet (use the original keys for data mapping)
    const exportKeys =
      this.columns && this.columns.length > 0
        ? this.columns.map((col) => col.key)
        : Object.keys(this.exportData[0]);

    const worksheet = XLSX.utils.json_to_sheet(processedData, {
      header: exportKeys,
    });
    XLSX.utils.sheet_add_aoa(worksheet, [headers], { origin: 'A1' });

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    XLSX.writeFile(workbook, `${this.fileName || 'Export'}.xlsx`);
  }

  private processRow(row: any, exportIdentifiers: (number | string)[]): any {
    const exportRow: any = {};
    exportIdentifiers.forEach((identifier) => {
      const column = this.allColumns.find(
        (col) => (col.id ?? col.key) === identifier
      );
      if (!column) return;

      const key = column.key;
      switch (key) {
        case 'status':
          exportRow[key] = row[key] === 1 ? 'Active' : 'Inactive';
          break;

        case 'expenseAssociated':
          exportRow[key] =
            row[key]?.map((item: any) => item.expense)?.join(', ') || '';
          break;
        case 'approvalUser':
          exportRow[key] =
            row[key]
              ?.map((item: any) =>
                `${item.name || ''} ${
                  item.approvalStatus ? `(${item.approvalStatus})` : ''
                }`.trim()
              )
              ?.join(', ') || '';
          break;
          case 'allApprovalsUser':
          exportRow[key] =
            row[key]
              ?.map((item: any) =>
                `(${item?.sequence}) ${item.name || ''} ${item?.remarks ? ' - ': ''} ${item?.remarks ? item?.remarks : ''}`.trim()
              )
              ?.join(', ') || '';
          break;

           case 'currentApprovalUser':
          exportRow[key] =
          row[key]
            ?.filter((item: any) => item?.approvalStatus == 1 && item?.viewStatus == 1)
            ?.map((item: any) =>
              `${item.name || ''} ${
                item.approvalStatus ? `` : ''
              }`.trim()
            )
            ?.join(' ') || '';

          break;
        case 'jobLineItems':
          console.log("0000000",row[key])
          exportRow[key] = row[key] ? `${row[key][0].routeSource}-${row[key][0].routeDestination}`
              :  row[key]?.routeSource || '';
          break;
        case 'invoiceLineItems':
          exportRow[key] =
            row[key]?.map((item: any) => item.expense)?.join(', ') || '';
          break;
        case 'venderInvoiceNumber':
          exportRow[key] =
            row[key]?.map((item: any) => item.invoiceNumber)?.join(', ') || '';
          break;

        case 'expenseModeMapping':
          exportRow[key] =
            row[key]?.map((item: any) => item.expenseMode)?.join(', ') || '';
          break;
        case 'attributes':
          exportRow[key] =
            row[key]?.map((item: any) => item.quickCodeName)?.join(', ') || '';
          break;
        case 'revenueAttributes':
          exportRow[key] =
            row[key]?.map((item: any) => item.attributeValue)?.join(', ') || '';
          break;
        case 'approvalHierarchy':
          exportRow[key] =
            row[key]
              ?.map((item: any) =>
                `${item.designation || ''} ${
                  item.condition ? `(${item.condition})` : ''
                }`.trim()
              )
              ?.join(', ') || '';
          break;
        case 'userRole':
          exportRow[key] =
            row[key]?.map((item: any) => item.roleDescription)?.join(', ') ||
            '';
          break;
        case 'warehouseList':
          exportRow[key] =
            row[key]
              ?.map((item: any) => {
                const client = item.clientName || '';
                const warehouse = item.warehouseName || '';
                return client && warehouse
                  ? `${client} - ${warehouse}`
                  : client || warehouse;
              })
              ?.join(', ') || '';
          break;
        default:
          const value = row[key];
          if (Array.isArray(value)) {
            exportRow[key] = value.join(', ');
          } else if (typeof value === 'object' && value !== null) {
            exportRow[key] = JSON.stringify(value);
          } else {
            exportRow[key] = value ?? '';
          }
      }
    });
    return exportRow;
  }

  parseCustomDate(dateStr: string): Date | null {
    const match =
      /^(\d{2})-(\d{2})-(\d{4}) (\d{2}:\d{2}:\d{2}) ([+-]\d{4})$/.exec(dateStr);
    if (!match) return null;

    const [_, day, month, year, time, offset] = match;
    const isoDate = `${year}-${month}-${day}T${time}${offset}`;
    return new Date(isoDate);
  }
}
